// extracted by mini-css-extract-plugin
module.exports = {"root":"slideshow-module--root--3ZP99","nav":"slideshow-module--nav--3G64m","carousel":"slideshow-module--carousel--18K96","slide":"slideshow-module--slide--3b5ZR"};